import { SusnetLink } from '../_wrapper/SusnetLink';

import IconChevronRight from '@public/new-icons/icon/icon_chevron-right.svg';

interface RoutesProps {
  path: string;
  breadcrumbName: string;
}

type Props = {
  routes: RoutesProps[];
};

export function Breadcrumb({ routes }: Props) {
  return (
    <div className='inline-flex items-center'>
      <ul className='inline-flex items-center'>
        {routes.slice(0, routes.length - 1).map((route, index) => (
          <li className='inline-flex items-center' key={index}>
            <SusnetLink href={route.path} className='text-body-small text-secondary'>
              {route.breadcrumbName}
            </SusnetLink>
            <div className='h-6 w-6'>
              <IconChevronRight />
            </div>
          </li>
        ))}
      </ul>
      <div className='text-body-small text-primary'>{routes.slice(-1)[0].breadcrumbName}</div>
    </div>
  );
}
